import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiBalance } from "@/shared/api/balance/api-balance";
import { getServerMessage } from "@/shared/lib/apiErrorHandler";

const apiBalance = new ApiBalance();

export const useDisableAutoTopUp = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (autoTopUpId: string) =>
      apiBalance.disableAutoTopUp(autoTopUpId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["auto-top-up"] });
    },
    onError: (error: unknown) => {
      console.error("Disable auto top-up failed:", error);
      throw new Error(
        getServerMessage(error, "Не удалось отключить автопополнение"),
      );
    },
  });
};
